import React from "react";
import { applyMiddleware, createStore as reduxCreateStore } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";

import rootReducer from ".";

const createStore = () => reduxCreateStore(rootReducer, applyMiddleware(thunk));

export default ({ element }) => (
    <Provider store={ createStore() }>{ element }</Provider>
);
